import React, { } from 'react';
import { View, Image, TextInput } from 'react-native';

import { CloseIcon, VerticalDivider } from './Common-Widget';

import AppStyles from "../../AppStyles";

import Colors from '../constants/AppColors';
import TextStyle from '../../TextStyle';
import { getImagePath } from '../services/CommonUtils';
import { IconView } from './CommonWidget/Icons';

export const CommonTextInput = (props) => {
    return <View style={[AppStyles.flexRowSpaceBetween, AppStyles.borderView, AppStyles.bgWhite,
    // paddingVertical = 15, beacuase of extra 1dp of borderWidth
    { paddingVertical: 15, paddingHorizontal: 12, width: props.width }]}>
        <TextInput style={[TextStyle.text14, {
            width: props.width - 56, color: Colors.grey.text
        }]} underlineColorAndroid="transparent"
            autoFocus={props?.autoFocus ?? false}
            value={props.value} placeholder={props.placeholder}
            onChangeText={(text) => props?.onChangeText(text)} />
        {props.value ? <CloseIcon onPress={() => { props?.onChangeText('') }} /> : null}
    </View>
}

export const NameTextInput = (props) => {
    var name = props.name
    var onChangeText = props.onChangeText
    const viewStyle = props?.viewStyle ?? null
    return <TextInput
        style={[TextStyle.text14, AppStyles.flexRowCenter, AppStyles.borderView,
        AppStyles.bgWhite, AppStyles.py10, AppStyles.px16, viewStyle]}
        underlineColorAndroid="transparent"
        placeholderTextColor={Colors.grey.fillerInfo}
        placeholder="Enter your name"
        maxLength={80} value={name}
        onChangeText={(text) => onChangeText(text.replace(/[^a-z A-Z]/g, ''))} />
}

export const PhoneNumberTextInput = (props) => {
    var phoneNumber = props.phoneNumber
    var onChangeText = props.onChangeText
    const inputRef = props.inputRef
    const viewStyle = props?.viewStyle ?? null
    return <View style={[AppStyles.flexRowStart, AppStyles.borderView,
    AppStyles.bgWhite, AppStyles.py8, AppStyles.px16, viewStyle,
    { alignItem: "center", paddingHorizontal: 16 }]}>
        <IconView icon={'call/black.svg'} size={18} />
        <VerticalDivider height={22} marginHorizontal={16} />
        <TextInput ref={inputRef}
            style={[TextStyle.text14, AppStyles.flexRowCenter]}
            underlineColorAndroid="transparent" maxLength={10}
            value={phoneNumber} keyboardType="numeric" autoFocus={true} placeholder={'Enter Mobile Number'}
            onChangeText={text => { onChangeText(text.replace(/[^0-9]/g, '')) }} />
    </View>
}